import { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useTimerCounter from "../hooks/use-timer";
import useSocket from "../hooks/use-socket";

export default function LoginOtp({ phone_number = "", full_name = "" }) {
  const navigate = useNavigate();
  const params = useParams();
  const [exam_id, package_id] = [...params.id?.split("__")];
  const [otp, setOtp] = useState("");

  const {
    socketConnections,
    closeSocket,
    loading,
    setLoading,
    onSocket,
    emitSocket,
  } = useSocket({
    headers: {
      phone_number,
    },
  });

  const { changeUnixHandler, seconds } = useTimerCounter();

  const sendEmit = (value = null) => {
    console.log("r");
    emitSocket(
      "getexam",
      JSON.stringify({
        send_otp: true,
        exam_id,
        package_id,
        otp: value,
      })
    );
  };

  useEffect(() => {
    if (!socketConnections) {
      return;
    }
    emitSocket(
      "getexam",
      JSON.stringify({
        exam_id,
        package_id,
      })
    );

    onSocket("getexam", (data) => {
      setLoading(false);
      console.log(data);
      if (data.code === 69459) {
        toast.error(data.message, {
          closeOnClick: true,
          position: "top-center",
          autoClose: 3000,
        });
        return;
      }
      if (data.code === 3829231) {
        changeUnixHandler(data.time.totalSecond);
        setOtp("12345");
      }
      if (data.code === 4565463) {
        localStorage.setItem("uuid", data.token);
        navigate("/start/" + params.id);
      }
    });
    return () => {
      closeSocket();
    };
  }, [socketConnections]);
  return (
    <form className="flex flex-col justify-center mt-20 items-center">
      <div className="grid gap-2 w-max shadow-2xl p-4">
        {loading ? (
          <div className="animate-pulse min-w-[320px]">
            <div className="h-3 rounded-sm bg-gray-300 w-1/3 mb-2"></div>
            <div className="h-3 rounded-sm bg-gray-300 w-full mb-2"></div>
            <div className="h-3 rounded-sm bg-gray-300 w-full mb-2"></div>
            <div className="flex justify-center flex-col !font-dana-normal items-center mt-4">
              <OTPInput
                containerStyle={{ direction: "ltr" }}
                value={otp}
                onChange={setOtp}
                numInputs={6}
                inputStyle={
                  "relative !aspect-square bg-gray-300 flex !h-9 !w-9 items-center justify-center  text-sm shadow-sm"
                }
                renderSeparator={<span className="w-4 text-center">-</span>}
                renderInput={(props) => <div {...props} />}
              />
            </div>
            <button
              disabled
              className="bg-gray-300 text-opacity-0 w-full mt-5 py-3 rounded-md text-white"
              type="button"
            >
              ارسال
            </button>
          </div>
        ) : (
          <>
            <span>{full_name}</span> کد تایید شما به شماره ی {phone_number}{" "}
            ارسال می شود
            <div className="flex justify-center flex-col !font-dana-normal items-center">
              <OTPInput
                containerStyle={{ direction: "ltr" }}
                value={otp}
                onChange={(value) => {
                  setOtp(value);
                  value.length === 6 && sendEmit(value);
                }}
                numInputs={6}
                inputStyle={
                  "relative !aspect-square flex !h-9 !w-9 items-center justify-center border border-primary-200 text-sm shadow-sm transition-all dark:border-slate-800"
                }
                renderSeparator={<span className="w-4 text-center">-</span>}
                renderInput={(props) => <input {...props} />}
              />
            </div>
            <button
              className="bg-primary-500 flex flex-row gap-2 justify-center w-full items-center mt-5 py-3 rounded-md text-white disabled:bg-gray-300"
              type="button"
              disabled={seconds}
              onClick={() => sendEmit()}
            >
              {!seconds ? "دریافت کد" : "ارسال مجدد"}
              {seconds ? <span>{seconds}</span> : ""}
            </button>
          </>
        )}
      </div>
    </form>
  );
}
